var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 131,
    viewBox: "0 0 138 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98067 95.2406L3.67417 96.3882L2.0102 103.188L5.3167 102.04L6.98067 95.2406ZM5.3167 102.04L29.3167 93.7098L30.9807 86.9105L6.98067 95.2406L5.3167 102.04Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98067 108.984L3.67417 110.132L2.0102 116.931L5.3167 115.783L6.98067 108.984ZM5.3167 115.783L29.3167 107.453L30.9807 100.654L6.98067 108.984L5.3167 115.783Z",
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.4668,
    y: 33.9667,
    width: 21.8667,
    height: 19.1333,
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4666 38.0667H113.333M91.4666 50.3666H113.333",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 98.3V114.7C28.6 121.493 23.0931 127 16.3 127V127C9.5069 127 4 121.493 4 114.7V57.3C4 50.5069 9.5069 45 16.3 45V45H28.6",
    stroke: "#000000",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7155 101.717V52.8583V23C28.7155 12.5066 37.2221 4 47.7155 4H114.833C125.327 4 133.833 12.5066 133.833 23V108C133.833 118.493 125.327 127 114.833 127H16.3",
    stroke: "#000000",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryNews);
export default __webpack_public_path__ + "static/media/industry-news.ca0d0d7e2807a6a510b4ca328bb4143d.svg";
export { ForwardRef as ReactComponent };